import React, {useState} from 'react';
import AdministeredDrugsCard from 'components/HealthRecords/Immunizations/AdministeredDrugsCard';
import YellowCard from 'components/HealthRecords/Immunizations/YellowCard';
import DefaultModal from 'components/Utils/DefaultModal';

const ViewYellowCardLink = ({text = "Open Schedule", patient, className, administeredDrugs}) => {

  const [modal, setModal] = useState(false);

  return (
    <>
        <span onClick={() => setModal(true)} className={className}>
          {text}
        </span>
      {modal && <DefaultModal
        className="large-modal"
        key="immunization-card-modal"
        content={
          administeredDrugs ?
            <AdministeredDrugsCard
              patient={patient}
              onClose={() => setModal(false)}
            /> :
            <YellowCard
              patient={patient}
              onClose={() => setModal(false)}
            />
        }
        isOpen={modal}
        onRequestClose={() => setModal(false)}
      />}
    </>
  );
}

export default ViewYellowCardLink;
